import React, { useEffect } from "react";
import Styles from "./index.module.scss";
import { Checkbox, Radio } from "antd";
import FieldWithErrorHaveLabel from "../../../../../../components/FieldWithErrorHaveLabel";
import Form, { useForm } from "rc-field-form";
import { ExtraRule, ExtraType } from "../../../../../../service/score";

interface Props {
    extraRule: ExtraType;
    expSwitch: boolean;
    setExtraRule?: (v: ExtraType) => void;
    disabled?: boolean;
}
const Index = ({ disabled, extraRule, expSwitch, setExtraRule }: Props) => {
    const [form] = useForm<ExtraRule>();

    useEffect(() => {
        if (expSwitch && extraRule) {
            form.setFieldsValue({
                config: extraRule?.config,
                gtHundred: extraRule?.gtHundred
            });
        }
    }, [expSwitch]);

    function onFinish(data: ExtraRule) {
        setExtraRule?.(data);
    }

    if (!expSwitch) {
        return null;
    }

    return (
        <Form
            form={form}
            className={Styles.root}
            onFinish={onFinish}
            onChange={form.submit}>
            <FieldWithErrorHaveLabel
                span={[6, 12]}
                align="middle"
                require
                preserve={false}
                rules={[{ message: "必须选择一个加分项", required: true }]}
                name="config"
                label="额外加分项目">
                <Checkbox.Group disabled={disabled}>
                    <Checkbox value="discuss">讨论加分</Checkbox>
                    <Checkbox value="other">其他</Checkbox>
                </Checkbox.Group>
            </FieldWithErrorHaveLabel>
            <FieldWithErrorHaveLabel
                span={[6, 12]}
                align="middle"
                name="gtHundred"
                preserve={false}
                initialValue="0"
                label="额外加分后，总成绩可以超过100分">
                <Radio.Group disabled={disabled}>
                    <Radio value="0">不可以</Radio>
                    <Radio value="1">可以</Radio>
                </Radio.Group>
            </FieldWithErrorHaveLabel>
        </Form>
    );
};

export default Index;
